import { Action } from 'redux';
import { ContractState, ContractUnloadState } from '../../states/ContractState';
import { Contract } from '../../../models/Entities/Contracts/Contract';

export default function ContractIAImportReducer(
  state: ContractState | undefined,
  action: Action
): ContractState {
  const currentState = state ?? ContractUnloadState;

  switch (action.type) {
    case 'CONTRACT_IAIMPORT_CREATE_SUCCESS': {
      const a: any = action;
      const process = a.process;
      if (!process || !process.contractID) return currentState;
      
      const contractId: number = process.contractID;
      const CurrentContract: Contract | undefined = currentState.list?.find((item: Contract) => item.id === contractId);
      if (!CurrentContract) return currentState;
      
      const updated: Contract = { ...CurrentContract, lastIAImportProcess: process };
      return {
        ...currentState,
        list: [...(currentState.list || []).filter((item: Contract) => item.id !== contractId), updated],
      };
    }
    case 'CONTRACT_IAIMPORT_GETLAST_SUCCESS': {
      const a: any = action;
      const contractId: number = a.contractId;
      const process = a.process || undefined;
      const CurrentContract: Contract | undefined = currentState.list?.find((item: Contract) => item.id === contractId);
      if (!CurrentContract) return currentState;
      const updated: Contract = { ...CurrentContract, lastIAImportProcess: process };
      return {
        ...currentState,
        list: [...(currentState.list || []).filter((item: Contract) => item.id !== contractId), updated],
      };
    }
    default:
      return currentState;
  }
}
